<template>
  <div class="model-layer" @touchstart="tap" @touchmove="move" @touchend="up" @touchcancel="up">
    <canvas ref="canvas"></canvas>
    <!-- <div class="model-layer__other-holes"></div> -->
    <!-- <div class="model-layer__flash"></div> -->
    <!-- <img v-if="loaded" src="/transition.gif" /> -->
    <div class="discover">
      <span>Discover the<br>Q-Uno in store</span>
    </div>
  </div>
</template>

<script>
import Aion from '@adoratorio/aion';
import * as THREE from 'three';
// import CustomMaterial from '@/assets/CustomMaterial';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader';
import { DRACOLoader } from 'three/examples/jsm/loaders/DRACOLoader';
import gsap from 'gsap';

export default {
  name: 'ModelLayer',

  data() {
    return {
      start: { x: 0, y: 0 },
      rotation: { x: Math.PI / 2, y: 0, z: 0 },
      renderer: null,
      camera: null,
      scene: null,
      bag: null,
      loaded: false,
      animating: true,
    };
  },

  mounted() {
    gsap.set('canvas', { autoAlpha: 0 });
    gsap.set('.discover', { autoAlpha: 0 });

    const i = new Image();
    i.src = '/transition.gif';
    if (typeof i.decode !== 'undefined') i.decode();

    this.scene = new THREE.Scene();
    this.camera = new THREE.PerspectiveCamera(
      75,
      window.innerWidth / window.innerHeight,
      0.1,
      1000,
    );
    this.camera.position.z = 0.5;

    this.renderer = new THREE.WebGLRenderer({
      canvas: this.$refs.canvas,
      alpha: true,
      antialias: true,
    });
    this.renderer.setSize(window.innerWidth, window.innerHeight);
    window.addEventListener('resize', () => {
      this.camera.aspect = window.innerWidth / window.innerHeight;
      this.camera.updateProjectionMatrix();
      this.renderer.setSize(window.innerWidth, window.innerHeight);
    });
    window.addEventListener('orientationchange', () => {
      this.camera.aspect = window.innerWidth / window.innerHeight;
      this.camera.updateProjectionMatrix();
      this.renderer.setSize(window.innerWidth, window.innerHeight);
    });
    this.renderer.setPixelRatio(devicePixelRatio);

    const aion = new Aion();
    aion.add(() => { this.frame(); }, 'render');

    const loader = new GLTFLoader();
    const dracoLoader = new DRACOLoader();
    dracoLoader.setDecoderPath('/draco/');
    loader.setDRACOLoader(dracoLoader);
    loader.load('/shoe.glb', (model) => {
      const bag = model.scene;
      this.bag = bag;
      // bag.rotation.z = -Math.PI / 2;
      bag.scale.set(0.6, 0.6, 0.6);
      window.dispatchEvent(new CustomEvent('loaddone'));
    });

    window.addEventListener('tapped', () => {
      setTimeout(() => {
        // gsap.set('.model-layer__flash', { autoAlpha: 1 });
        // gsap.set('.model-layer__other-holes', { autoAlpha: 1 });
        this.scene.add(this.bag);
        // gsap.to('.model-layer__other-holes', { autoAlpha: 1, duration: 2, ease: 'power3.in' });
        gsap.to('canvas', { autoAlpha: 1, duration: 2, delay: 0, ease: 'power3.in' }); // eslint-disable-line
        gsap.to(this.rotation, {
          z: `-=${Math.PI * 3}`,
          ease: 'power3.inOut',
          duration: 5,
          delay: 0.2,
        }).then(() => {
          this.animating = false;
          gsap.to('.discover', { autoAlpha: 1 });
        });
      }, 200);
    });

    // const plight = new THREE.PointLight(0xffffff, 20, 1);
    // plight.position.z = 1;
    // this.scene.add(plight);

    const alight = new THREE.AmbientLight(0xaaaaaa, 1);
    this.scene.add(alight);

    // const slight = new THREE.SpotLight(0xffffff, 2);
    // slight.position.set(0, 2, 2);
    // this.scene.add(slight);

    window.addEventListener('tapped', () => {
      this.loaded = true;
      setTimeout(() => aion.start(), 800);
    });
  },

  methods: {
    frame() {
      this.bag.rotation.x = -this.rotation.x;
      this.bag.rotation.y = -this.rotation.y;
      this.bag.rotation.z = -this.rotation.z;
      this.renderer.render(this.scene, this.camera);
      // if (this.autorotation) this.rotation.x -= 0.01;
    },
    tap(event) {
      event.preventDefault();
      if (this.animating) return;
      this.start.z = event.touches[0].clientX;
      this.start.x = event.touches[0].clientY;
    },
    move(event) {
      event.preventDefault();
      if (this.animating) return;
      this.rotation.z += (this.start.x - event.touches[0].clientX) * 0.008;
      this.rotation.x += (this.start.y - event.touches[0].clientY) * 0.008;
      this.start = {
        z: event.touches[0].clientX,
        x: event.touches[0].clientY,
      };
    },
    up() {
      // this.autorotation = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.model-layer {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;

  canvas {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 2;
  }

  img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  &__flash {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 3;

    background-color: white;
  }

  &__other-holes {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 3;

    background-image: url('/other-holes.png');
    background-position: center center;
    background-size: cover;
  }

  .discover {
    position: absolute;
    bottom: 10px;
    color: white;
    font-size: 1em;
    width: 100%;
    text-align: center;
  }
}
</style>
